<template>
    <div class="app-container">
        <div style="    display: flex;justify-content: center;font-size: 22px;padding: 12px;">
            企业证照一览表
        </div>
          <data-table
      v-if="showView==='listpage'"
      :module-info="moduleInfo"
      :on-cell-click="onCellClick"
      :tb-columns="tbColumns"
      :toolbar-btns="listpageBtns"
      :on-list-data-before-load="onListDataBeforeLoad"
      :on-list-data-loaded="onListDataLoaded"
      :on-delete-successed="onDeleteSuccessed"
>
  </data-table>
      <Basicform
      ref="basicform"
        :title="formTitle"
        :module-code="moduleInfo.moduleCode"
        :win-width="moduleInfo.winWidth"
        :win-height="moduleInfo.winHeight"
        :toolbar-btns="busiformBtns"
        :on-basic-form-before-open="onBasicFormBeforeOpen"
        :on-basic-form-opened="onBasicFormOpened"
        :on-basic-form-before-submit="onBasicFormBeforeSubmit"
        :on-basic-form-submited="onBasicFormSubmited"
      >
        <template #default="slotProps">
          <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
        </template>
      </Basicform>
    </div>
  </template>

<script>
export default {
    data: function() {
        return {
            showView: 'listpage',
            loginUser: {},
            moduleInfo: {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/zzgl/certInfo/formAll.html', 'winWidth': 1000, 'delUrl': 'zzgl/certInfo/delete', 'addNewUrl': 'zzgl/certInfo/addNew', 'insertUrl': 'zzgl/certInfo/insert', 'moduleCode': 'certInfo', 'listAdvSearchExpandPanel': 0, 'winHeight': 600, 'updateUrl': 'zzgl/certInfo/update', 'listDataUrl': 'zzgl/certInfo/listdataAllCount', 'getByIdUrl': 'zzgl/certInfo/getById', 'listAdvSearchAllFields': 0},
            tbColumns: [{'field': 'state', 'checkbox': true, 'width': '45px', 'sortable': false, 'align': 'center'}, {'listAdvSearchElement': '', 'field': 'index', 'width': '45px', 'sortable': false, 'propType': '', 'align': 'center', 'title': '序号', 'searchable': false}, {'listAdvSearchElement': 'input', 'listAdvSearchIndex': 0, 'field': 'name', 'width': '', 'sortable': false, 'propType': 'String', 'align': 'left', 'title': '证照名称', 'searchable': true}, {'listAdvSearchElement': 'select', 'listAdvSearchIndex': 1, 'field': 'certType', 'width': '120px', 'elementFormatter': '2：组织机构代码证\n3：税务登记证\n4：银行开户许可证\n1：营业执照', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '证照类型 ', 'searchable': true}, {'propFormatter': 'format：yyyy-MM-dd', 'listAdvSearchElement': 'date', 'listAdvSearchIndex': 2, 'field': 'issueDate', 'width': '150px', 'elementFormatter': 'format：yyyy-MM-dd', 'sortable': true, 'propType': 'java.util.Date', 'align': 'center', 'title': '发证日期', 'searchable': true}, {'propFormatter': 'format：yyyy-MM-dd', 'listAdvSearchElement': 'date', 'listAdvSearchIndex': 3, 'field': 'expiredDate', 'width': '150px', 'elementFormatter': 'format：yyyy-MM-dd', 'sortable': true, 'propType': 'java.util.Date', 'align': 'center', 'title': '有效日期', 'searchable': true}, {'propFormatter': 'format：yyyy-MM-dd', 'listAdvSearchElement': '', 'listAdvSearchIndex': 4, 'field': 'checkDate', 'width': '150px', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '下次年审时间', 'searchable': false, 'elementFormatter': 'format：yyyy-MM-dd'}, {'listAdvSearchElement': '', 'listAdvSearchIndex': 5, 'field': 'checkCount', 'width': '100px', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '年审次数', 'searchable': false}, {'listAdvSearchElement': '', 'listAdvSearchIndex': 6, 'field': 'modifyCount', 'width': '100px', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '变更次数', 'searchable': false}, {'listAdvSearchElement': '', 'listAdvSearchIndex': 7, 'field': 'useCount', 'width': '100px', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '借用次数', 'searchable': false}, {'listAdvSearchElement': '', 'listAdvSearchIndex': 8, 'field': 'copyUseCount', 'width': '130px', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '复印件使用次数', 'searchable': false}, {'listAdvSearchElement': 'input', 'listAdvSearchIndex': 9, 'field': 'mrgDeptName', 'width': '80px', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '保管部门', 'searchable': true}, {'listAdvSearchElement': 'input', 'listAdvSearchIndex': 10, 'field': 'mrgStaffName', 'width': '80px', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '保管人', 'searchable': true}, {'listAdvSearchElement': '', 'listAdvSearchIndex': 11, 'field': 'status', 'width': '60px', 'elementFormatter': '1：在库\n2：借出\n3：变更中\n4：注销', 'sortable': false, 'propType': 'String', 'align': 'center', 'title': '状态 ', 'searchable': false}],
            listStyle: {},
            listpageBtns: [{'btnName': '导出', 'btnIcon': 'export.svg', 'btnClick': 'exportWform();', 'btnPermission': 'exportWform', 'id': 'btn_edit', 'btnType': 'toolbar'}],
            busiformBtns: [],
            formTitle: '单位证照信息',

            moduleInfo1: {}

        }
    },
    computed: {
    },
    watch: {
        $route: function(a, b) {
            this.setShowView()
        }
    },
    created: function() {
        //列表页面配置ID
        this.moduleInfo.listpageViewUrl = '/zzgl/certInfo/listAll.html'
        const _this = this
        this.listpageBtns.forEach(function(btn) {
            btn.btnParams = null
            if (typeof btn.btnClick === 'string') {
                let btnClick = btn.btnClick
                if (btn.btnClick.indexOf('(') !== -1) {
                    let btnParams = btnClick.substring(btnClick.indexOf('(') + 1, btnClick.lastIndexOf(')'))
                    if (btnParams !== '') {
                        btnParams = btnParams.replace(/'/g, '').replace(/ /g, '').split(',')
                        btn.btnParams = btnParams
                    }
                    btnClick = btnClick.split('(')[0]
                }
                if (_this[btnClick]) {
                    btn.btnClick = _this[btnClick]
                }
            }
        })

        this.$bus.on('cellClick1', this.cellClick1)

        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    beforeDestroy: function() {
    },
    mounted: function() {
        this.setShowView()
    },
    methods: {
        setShowView: function() {
            if (this.$route.fullPath.indexOf('itemurl=') !== -1) {
                this.showView = 'mainform'
            } else {
                this.showView = 'listpage'
            }
        },
        /**
          * 加载数据准备，qparams为查询参数对象，不需要返回值
          */
        onListDataBeforeLoad: function($scope, qparams) {
            this.loginUser = $scope.loginUser

            console.log('certInfo listdata before load..')
        },
        /**
          * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
          */
        onListDataLoaded: function($scope, pageInfo) {
            console.log('certInfo listdata loaded')
        },
        /**
          * 数据删除成功，ids为已删除成功的certInfo对象ID数组，即将刷新列表，不需要返回值
          */
        onDeleteSuccessed: function($scope, ids) {
            console.log('certInfo delete successed')
        },
        /**
          * 表单打开检查，vo为已加载certInfo对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
          */
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('certInfo form before open')
            defer.resolve(true)
        },
        /**
           * 表单打开完成，vo为已加载的certInfo对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
          */
        onBasicFormOpened: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('certInfo form opened')
        },
        /**
           * 表单提交事件，可执行业务数据高级校验，vo为待提交的certInfo对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
           */
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            /*this.$confirm('您是否确认提交保存?', '确认操作', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              })
                  .then(() => {
                      this.getTreeData()
                      defer.resolve(true)
                  })
                  .catch(err => {
                      defer.reject(err)
                  })*/

            if (process.env.NODE_ENV === 'development') console.log('certInfo form submit validation success')
            defer.resolve(true)
        },
        /**
          * 表单提交完成，vo为已保存成功的certInfo对象，窗口即将关闭，不需要返回值
          */
        onBasicFormSubmited: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('certInfo form submited')
        },

        onCellClick(row) {
            console.log('4', row.id)
            var _this = this
            _this.formTitle = '证照信息'
            _this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: ''
                }
            ]
            _this.moduleInfo.getByIdUrl = 'zzgl/certInfo/getById',
            _this.moduleInfo.winWidth = 1000,
            _this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/zzgl.certInfo.formAll.vue?sysCode='
            _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', _this.moduleInfo, row, 0, (res) => {})
            })
        },
        //// 查看详情
        cellClick1(row) {
            //debugger
            console.log('27', row)
            var _this = this
            _this.formTitle = '年审记录'
            _this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: ''
                }
            ]
            _this.moduleInfo.getByIdUrl = 'zzgl/certCheckRecord/getById'
            _this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/zzgl.certCheckRecord.form1.vue?sysCode='
            _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', _this.moduleInfo, row, 0, (res) => {
                    _this.moduleInfo.getByIdUrl = 'zzgl/certInfo/getById'
                })
            })
        }

    }
}
</script>

  <style scoped>
  </style>
